import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import utils from 'helpers/utils';
import translate from 'components/hoc/translate';
import { fetchIdFromResource } from 'store/actions/reference/fetchReference';

class MobianReferenceById extends React.Component {
    static propTypes = {
        resource: PropTypes.string.isRequired,
        translate: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
    }

    componentDidMount() {
        if (this.props.value !== 'undefined' || this.props.value !== 0) {
            this.props.fetchIdFromResource({
                id: this.props.value,
                resource: this.props.resource,
                type: this.props.type,
            });
        }
    }

    showData() {
        if (!this.props.value) {
            return null;
        }

        const { property, translate } = this.props;

        if (utils.isEmpty(property)) {
            return <i>{ translate(`fields.empty`) }</i>;
        }

        return (
            <div>{ property.name }</div>
        );
    }

    render() {
        return this.showData();
    }
}

MobianReferenceById.propTypes = {
    fetchIdFromResource: PropTypes.func.isRequired,
    property: PropTypes.object,
};

const HOCMobianReferenceById = connect(
    (state, props) => {
        return {
            property: state.properties.data[props.value],
        };
    },
    {
        fetchIdFromResource: fetchIdFromResource,
    }
)(MobianReferenceById);

export default translate(HOCMobianReferenceById);



// WEBPACK FOOTER //
// ./src/components/field/MobianReferenceById.js